import React from 'react';
import styled from 'styled-components';
import { Tabs, Tab } from '@material-ui/core';

export const StyledTabs = styled(props => {
  return <Tabs {...props} classes={{ indicator: 'indicator' }}></Tabs>;
})`
  && {
    background-color: #fafafa;
    border-radius: 8px 8px 0 0;
    .MuiTab-wrapper {
      justify-content: center;
      flex-direction: row;
    }
    button {
      padding: 15px 22px;
    }
  }
`;
export const StyledTab = styled(Tab)`
  && {
    color: #000000;
    background: #e6f1fa;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.12);
    font-size: 17px !important;
    line-height: 20px;
    font-weight: 500;
    opacity: unset;
    text-transform: none;
    border-right: 1px solid #fff;
    border-left: 1px solid #fff;
    border-radius: 4px 4px 0px 0px;
    &:focus {
      color: #0880bc !important;
      background-color: #fff !important;
    }
    &&.Mui-selected {
      background-color: #fff;
    }
  }
`;
export const Container = styled.main`
  background-color: #fff;
  padding: 16px;
`;

export const FeeNoteButton = styled.div`
  width: 210px;
  min-height: 43px;
  margin-left: auto;
  background: #fbfbfb 0% 0% no-repeat padding-box;
  border-radius: 4px;
  padding: 2px;
  .drop-down-button {
    font-size: 13px;
    justify-content: space-between;
    width: 100%;
    font-weight: 500;
    color: #0075c9;
    text-transform: none;
    opacity: 1;
    letter-spacing: 0.02px;
    text-transform: uppercase;
  }
`;
